import {
  TREQUEST_CREATE_TICKET,
  TREQUEST_GET_ALL_EMPLOYEE_TICKETS,
  TREQUEST_GET_ALL_MAINTENANCE_TICKETS,
  TRESPONSE_GET_ALL_MAINTENANCE_TICKETS,
  TREQUEST_CREATE_MAINTENANCE_TICKET,
  TREQUEST_START_MAINTENANCE_TICKET,
  TREQUEST_COMPLETE_MAINTENANCE_TICKET,
  TREQUEST_GET_MACHINE_TICKET_HISTORY,
  TREQUEST_GET_SHIFT_DETAILS,
  TREQUEST_REASSIGN_MECHANIC,
  TREQUEST_UPDATE_ISSUE,
  TREQUEST_UPDATE_REVISION,
  TRESPONSE_BREAKDOWN_REASON_SOLUTION_LIST,
  TRESPONSE_GET_ALL_EMPLOYEE_TICKETS,
  TRESPONSE_GET_EMPLOYEE_TICKET_SUMMARY,
  TRESPONSE_GET_MACHINE_TICKET_HISTORY,
  TRESPONSE_GET_SHIFT_DETAILS,
  TShiftRevision,
  TREQUEST_REASSIGN_MAINTENANCE_MECHANIC,
  TMaintenanceTicketStatus,
  TTicketId,
  TREQUEST_GET_SPAREPART_REQUEST_BY_SOURCE,
  TRaiseARequestId,
  TRESPONSE_GET_SPAREPART_REQUEST_BY_SOURCE,
  TMachineIssueTicketsFetchReason,
  TMaintenanceTicketsFetchReason,
  GET_SPAREPART_REQUEST_REASONS,
  TREQUEST_MARK_CHECKLIST_COMPLETED,
  TFilterSelected,
  TRESPONSE_GET_TICKET_SUMMARY_ANALYTICS,
  TRESPONSE_GET_MAINTENANCE_TICKET_HISTORY,
  TRESPONSE_GET_EMPLOYEE_TICKET_DETAILS,
  TUserPaginationOption,
  TM8MachineId,
} from '@monorepo/types';
import { Action } from '@ngrx/store';
import { TTicketManagementActionType } from './ticket-management.models';

export class CreateNewTicket implements Action {
  readonly type = TTicketManagementActionType.CreateNewTicket;
  constructor(public payload: Omit<TREQUEST_CREATE_TICKET, 'factoryId'>) {}
}

export class CreateNewTicketSuccess implements Action {
  readonly type = TTicketManagementActionType.CreateNewTicketSuccess;
}

export class CreateNewTicketFailure implements Action {
  readonly type = TTicketManagementActionType.CreateNewTicketFailure;
}

export class AssignTicketToMe implements Action {
  readonly type = TTicketManagementActionType.AssignTicketToMe;
  constructor(public payload: Omit<TREQUEST_CREATE_TICKET, 'factoryId'>) {}
}

export class AssignTicketToMeSuccess implements Action {
  readonly type = TTicketManagementActionType.AssignTicketToMeSuccess;
}

export class AssignTicketToMeFailure implements Action {
  readonly type = TTicketManagementActionType.AssignTicketToMeFailure;
}

export class ReAssignMechanic implements Action {
  readonly type = TTicketManagementActionType.ReAssignMechanic;
  constructor(public payload: Omit<TREQUEST_REASSIGN_MECHANIC, 'factoryId'>) {}
}

export class UpdateIssue implements Action {
  readonly type = TTicketManagementActionType.UpdateIssue;
  constructor(public payload: Omit<TREQUEST_UPDATE_ISSUE, 'factoryId'>) {}
}

export class UpdateIssueSuccess implements Action {
  readonly type = TTicketManagementActionType.UpdateIssueSuccess;
}

export class UpdateIssueFailure implements Action {
  readonly type = TTicketManagementActionType.UpdateIssueFailure;
}

export class ReAssignMechanicSuccess implements Action {
  readonly type = TTicketManagementActionType.ReAssignMechanicSuccess;
}

export class ReAssignMechanicFailure implements Action {
  readonly type = TTicketManagementActionType.ReAssignMechanicFailure;
}

export class ReIssueTicket implements Action {
  readonly type = TTicketManagementActionType.ReIssueTicket;
  constructor(public ticketId: TTicketId) {}
}

export class ReIssueTicketSuccess implements Action {
  readonly type = TTicketManagementActionType.ReIssueTicketSuccess;
}

export class ReIssueTicketFailure implements Action {
  readonly type = TTicketManagementActionType.ReIssueTicketFailure;
}

export class ApproveTicket implements Action {
  readonly type = TTicketManagementActionType.ApproveTicket;
  constructor(public ticketId: TTicketId) {}
}

export class ApproveTicketSuccess implements Action {
  readonly type = TTicketManagementActionType.ApproveTicketSuccess;
}

export class ApproveTicketFailure implements Action {
  readonly type = TTicketManagementActionType.ApproveTicketFailure;
}

export class PickupTicket implements Action {
  readonly type = TTicketManagementActionType.PickupTicket;
  constructor(public ticketId: TTicketId) {}
}

export class PickupTicketSuccess implements Action {
  readonly type = TTicketManagementActionType.PickupTicketSuccess;
}

export class PickupTicketFailure implements Action {
  readonly type = TTicketManagementActionType.PickupTicketFailure;
}

export class MarkTicketAsCompleted implements Action {
  readonly type = TTicketManagementActionType.MarkTicketAsCompleted;
  constructor(public ticketId: TTicketId, public isActiveMachine: boolean) {}
}

export class MarkTicketAsCompletedSuccess implements Action {
  readonly type = TTicketManagementActionType.MarkTicketAsCompletedSuccess;
}

export class MarkTicketAsCompletedFailure implements Action {
  readonly type = TTicketManagementActionType.MarkTicketAsCompletedFailure;
}

export class ResetEmployeeTickets implements Action {
  readonly type = TTicketManagementActionType.ResetEmployeeTickets;
}

export class GetAllEmployeeTickets implements Action {
  readonly type = TTicketManagementActionType.GetAllEmployeeTickets;
  constructor(
    public payload: Omit<TREQUEST_GET_ALL_EMPLOYEE_TICKETS, 'factoryId'>,
    public fetchReason: TMachineIssueTicketsFetchReason,
  ) {}
}

export class GetAllEmployeeTicketsSuccess implements Action {
  readonly type = TTicketManagementActionType.GetAllEmployeeTicketsSuccess;
  constructor(public res: TRESPONSE_GET_ALL_EMPLOYEE_TICKETS, public fetchReason: TMachineIssueTicketsFetchReason) {}
}

export class GetAllEmployeeTicketsFailure implements Action {
  readonly type = TTicketManagementActionType.GetAllEmployeeTicketsFailure;
}

export class GetEmployeeTicketDetails implements Action {
  readonly type = TTicketManagementActionType.GetEmployeeTicketDetails;
  constructor(public ticketId: TTicketId) {}
}

export class GetEmployeeTicketDetailsSuccess implements Action {
  readonly type = TTicketManagementActionType.GetEmployeeTicketDetailsSuccess;
  constructor(public res: TRESPONSE_GET_EMPLOYEE_TICKET_DETAILS) {}
}

export class GetEmployeeTicketDetailsFailure implements Action {
  readonly type = TTicketManagementActionType.GetEmployeeTicketDetailsFailure;
}

export class GetMachineTicketHistory implements Action {
  readonly type = TTicketManagementActionType.GetMachineTicketHistory;
  constructor(public payload: Omit<TREQUEST_GET_MACHINE_TICKET_HISTORY, 'factoryId'>) {}
}

export class GetMachineTicketHistorySuccess implements Action {
  readonly type = TTicketManagementActionType.GetMachineTicketHistorySuccess;
  constructor(public res: TRESPONSE_GET_MACHINE_TICKET_HISTORY) {}
}

export class GetMachineTicketHistoryFailure implements Action {
  readonly type = TTicketManagementActionType.GetMachineTicketHistoryFailure;
}

export class GetMachineMaintenanceHistory implements Action {
  readonly type = TTicketManagementActionType.GetMachineMaintenanceHistory;
  constructor(public payload: Omit<TREQUEST_GET_MACHINE_TICKET_HISTORY, 'factoryId'>) {}
}

export class GetMachineMaintenanceHistorySuccess implements Action {
  readonly type = TTicketManagementActionType.GetMachineMaintenanceHistorySuccess;
  constructor(public res: TRESPONSE_GET_MAINTENANCE_TICKET_HISTORY) {}
}

export class GetMachineMaintenanceHistoryFailure implements Action {
  readonly type = TTicketManagementActionType.GetMachineMaintenanceHistoryFailure;
}

export class GetEmployeeTicketSummary implements Action {
  readonly type = TTicketManagementActionType.GetEmployeeTicketSummary;
  constructor(public selectedFilters: TFilterSelected[]) {}
}

export class GetEmployeeTicketSummarySuccess implements Action {
  readonly type = TTicketManagementActionType.GetEmployeeTicketSummarySuccess;
  constructor(public res: TRESPONSE_GET_EMPLOYEE_TICKET_SUMMARY) {}
}

export class GetEmployeeTicketSummaryFailure implements Action {
  readonly type = TTicketManagementActionType.GetEmployeeTicketSummaryFailure;
}

export class GetTicketSummaryAnalytics implements Action {
  readonly type = TTicketManagementActionType.GetTicketSummaryAnalytics;
  constructor(public selectedFilters: TFilterSelected[]) {}
}

export class GetTicketSummaryAnalyticsSuccess implements Action {
  readonly type = TTicketManagementActionType.GetTicketSummaryAnalyticsSuccess;
  constructor(public res: TRESPONSE_GET_TICKET_SUMMARY_ANALYTICS) {}
}

export class GetTicketSummaryAnalyticsFailure implements Action {
  readonly type = TTicketManagementActionType.GetTicketSummaryAnalyticsFailure;
}

export class GetBreakdownReasonAndSolutions implements Action {
  readonly type = TTicketManagementActionType.GetBreakdownReasonAndSolutions;
  constructor(
    public factorySerialNumber: TREQUEST_CREATE_TICKET['machineFactorySerialNumber'],
    public machineId: TM8MachineId,
  ) {}
}

export class GetBreakdownReasonAndSolutionsSuccess implements Action {
  readonly type = TTicketManagementActionType.GetBreakdownReasonAndSolutionsSuccess;
  constructor(public res: TRESPONSE_BREAKDOWN_REASON_SOLUTION_LIST) {}
}

export class GetBreakdownReasonAndSolutionsFailure implements Action {
  readonly type = TTicketManagementActionType.GetBreakdownReasonAndSolutionsFailure;
}

export class GetFactoryShiftRevisionDetails implements Action {
  readonly type = TTicketManagementActionType.GetFactoryShiftRevisionDetails;
  constructor(public payload: Omit<TREQUEST_GET_SHIFT_DETAILS, 'factoryId'>) {}
}

export class GetFactoryShiftRevisionDetailsSuccess implements Action {
  readonly type = TTicketManagementActionType.GetFactoryShiftRevisionDetailsSuccess;
  constructor(public res: TRESPONSE_GET_SHIFT_DETAILS) {}
}

export class GetFactoryShiftRevisionDetailsFailure implements Action {
  readonly type = TTicketManagementActionType.GetFactoryShiftRevisionDetailsFailure;
}

export class UpdateShiftRevision implements Action {
  readonly type = TTicketManagementActionType.UpdateShiftRevision;
  constructor(
    public payload: Omit<TREQUEST_UPDATE_REVISION, 'factoryId'>,
    public getFactoryShiftPayload: Omit<TREQUEST_GET_SHIFT_DETAILS, 'factoryId'>,
  ) {}
}

export class UpdateShiftRevisionSuccess implements Action {
  readonly type = TTicketManagementActionType.UpdateShiftRevisionSuccess;
}

export class UpdateShiftRevisionFailure implements Action {
  readonly type = TTicketManagementActionType.UpdateShiftRevisionFailure;
}

export class DeleteShiftRevision implements Action {
  readonly type = TTicketManagementActionType.DeleteShiftRevision;
  constructor(
    public shiftRevisionId: TShiftRevision['shiftRevisionId'],
    public getFactoryShiftPayload: Omit<TREQUEST_GET_SHIFT_DETAILS, 'factoryId'>,
  ) {}
}

export class DeleteShiftRevisionSuccess implements Action {
  readonly type = TTicketManagementActionType.DeleteShiftRevisionSuccess;
}

export class DeleteShiftRevisionFailure implements Action {
  readonly type = TTicketManagementActionType.DeleteShiftRevisionFailure;
}

export class GetAllMaintenanceTickets implements Action {
  readonly type = TTicketManagementActionType.GetAllMaintenanceTickets;
  constructor(
    public payload: TREQUEST_GET_ALL_MAINTENANCE_TICKETS,
    public fetchReason: TMaintenanceTicketsFetchReason,
  ) {}
}
export class GetAllMaintenanceTicketsSuccess implements Action {
  readonly type = TTicketManagementActionType.GetAllMaintenanceTicketsSuccess;
  constructor(public res: TRESPONSE_GET_ALL_MAINTENANCE_TICKETS, public fetchReason: TMaintenanceTicketsFetchReason) {}
}

export class GetAllMaintenanceTicketsFailure implements Action {
  readonly type = TTicketManagementActionType.GetAllMaintenanceTicketsFailure;
}

export class CreateMaintenanceTicket implements Action {
  readonly type = TTicketManagementActionType.CreateMaintenanceTicket;
  constructor(public payload: TREQUEST_CREATE_MAINTENANCE_TICKET) {}
}

export class CreateMaintenanceTicketSuccess implements Action {
  readonly type = TTicketManagementActionType.CreateMaintenanceTicketSuccess;
}

export class CreateMaintenanceTicketFailure implements Action {
  readonly type = TTicketManagementActionType.CreateMaintenanceTicketFailure;
}

export class StartMaintenanceTicket implements Action {
  readonly type = TTicketManagementActionType.StartMaintenanceTicket;
  constructor(public payload: TREQUEST_START_MAINTENANCE_TICKET) {}
}

export class StartMaintenanceTicketSuccess implements Action {
  readonly type = TTicketManagementActionType.StartMaintenanceTicketSuccess;
}

export class StartMaintenanceTicketFailure implements Action {
  readonly type = TTicketManagementActionType.StartMaintenanceTicketFailure;
}

export class CompleteMaintenanceTicket implements Action {
  readonly type = TTicketManagementActionType.CompleteMaintenanceTicket;
  constructor(public payload: TREQUEST_COMPLETE_MAINTENANCE_TICKET) {}
}

export class CompleteMaintenanceTicketSuccess implements Action {
  readonly type = TTicketManagementActionType.CompleteMaintenanceTicketSuccess;
}

export class CompleteMaintenanceTicketFailure implements Action {
  readonly type = TTicketManagementActionType.CompleteMaintenanceTicketFailure;
}

export class ReAssignMaintenanceMechanic implements Action {
  readonly type = TTicketManagementActionType.ReAssignMaintenanceMechanic;
  constructor(
    public payload: TREQUEST_REASSIGN_MAINTENANCE_MECHANIC,
    public currentTicketStatus: TMaintenanceTicketStatus,
  ) {}
}

export class ReAssignMaintenanceMechanicSuccess implements Action {
  readonly type = TTicketManagementActionType.ReAssignMaintenanceMechanicSuccess;
}

export class ReAssignMaintenanceMechanicFailure implements Action {
  readonly type = TTicketManagementActionType.ReAssignMaintenanceMechanicFailure;
}

export class ResetSparepartRequestDetails implements Action {
  readonly type = TTicketManagementActionType.ResetSparepartRequestDetails;
}

export class GetSparepartRequestBySource implements Action {
  readonly type = TTicketManagementActionType.GetSparepartRequestBySource;
  constructor(public payload: TREQUEST_GET_SPAREPART_REQUEST_BY_SOURCE) {}
}

export class GetSparepartRequestBySourceSuccess implements Action {
  readonly type = TTicketManagementActionType.GetSparepartRequestBySourceSuccess;
  constructor(public res: TRESPONSE_GET_SPAREPART_REQUEST_BY_SOURCE) {}
}

export class GetSparepartRequestBySourceFailure implements Action {
  readonly type = TTicketManagementActionType.GetSparepartRequestBySourceFailure;
}

export class CancelSparepartRequest implements Action {
  readonly type = TTicketManagementActionType.CancelSparepartRequest;
  constructor(public requestId: TRaiseARequestId) {}
}

export class CancelSparepartRequestSuccess implements Action {
  readonly type = TTicketManagementActionType.CancelSparepartRequestSuccess;
}

export class CancelSparepartRequestFailure implements Action {
  readonly type = TTicketManagementActionType.CancelSparepartRequestFailure;
}

export class GetSparepartRequestReasons implements Action {
  readonly type = TTicketManagementActionType.GetSparepartRequestReasons;
  constructor(public sparePartType: TRESPONSE_GET_SPAREPART_REQUEST_BY_SOURCE['requests'][number]['sparePartType']) {}
}

export class GetSparepartRequestReasonsSuccess implements Action {
  readonly type = TTicketManagementActionType.GetSparepartRequestReasonsSuccess;
  constructor(public res: GET_SPAREPART_REQUEST_REASONS) {}
}

export class GetSparepartRequestReasonsFailure implements Action {
  readonly type = TTicketManagementActionType.GetSparepartRequestReasonsFailure;
}

export class MarkChecklistCompleted implements Action {
  readonly type = TTicketManagementActionType.MarkChecklistCompleted;
  constructor(
    public payload: TREQUEST_MARK_CHECKLIST_COMPLETED,
    public ticketStatus: TREQUEST_GET_ALL_MAINTENANCE_TICKETS['maintenanceTicketStatus'],
  ) {}
}

export class MarkChecklistCompletedSuccess implements Action {
  readonly type = TTicketManagementActionType.MarkChecklistCompletedSuccess;
}

export class MarkChecklistCompletedFailure implements Action {
  readonly type = TTicketManagementActionType.MarkChecklistCompletedFailure;
}

export class SetEmployeeTicketsPagination implements Action {
  readonly type = TTicketManagementActionType.SetEmployeeTicketsPagination;
  constructor(public userPaginationOption: TUserPaginationOption) {}
}

export class SetMaintenanceTicketsPagination implements Action {
  readonly type = TTicketManagementActionType.SetMaintenanceTicketsPagination;
  constructor(public userPaginationOption: TUserPaginationOption) {}
}

export type TTicketManagementActions =
  | CreateNewTicket
  | CreateNewTicketSuccess
  | CreateNewTicketFailure
  | AssignTicketToMe
  | AssignTicketToMeSuccess
  | AssignTicketToMeFailure
  | UpdateIssue
  | UpdateIssueSuccess
  | UpdateIssueFailure
  | ReAssignMechanic
  | ReAssignMechanicSuccess
  | ReAssignMechanicFailure
  | ReIssueTicket
  | ReIssueTicketSuccess
  | ReIssueTicketFailure
  | ApproveTicket
  | ApproveTicketSuccess
  | ApproveTicketFailure
  | MarkTicketAsCompleted
  | MarkTicketAsCompletedSuccess
  | MarkTicketAsCompletedFailure
  | PickupTicket
  | PickupTicketSuccess
  | PickupTicketFailure
  | ResetEmployeeTickets
  | GetAllEmployeeTickets
  | GetAllEmployeeTicketsSuccess
  | GetAllEmployeeTicketsFailure
  | GetMachineTicketHistory
  | GetMachineTicketHistorySuccess
  | GetMachineTicketHistoryFailure
  | GetMachineMaintenanceHistory
  | GetMachineMaintenanceHistorySuccess
  | GetTicketSummaryAnalyticsFailure
  | GetEmployeeTicketSummary
  | GetEmployeeTicketSummarySuccess
  | GetEmployeeTicketSummaryFailure
  | GetEmployeeTicketDetails
  | GetEmployeeTicketDetailsSuccess
  | GetEmployeeTicketDetailsFailure
  | GetTicketSummaryAnalytics
  | GetTicketSummaryAnalyticsSuccess
  | GetTicketSummaryAnalyticsFailure
  | GetBreakdownReasonAndSolutions
  | GetBreakdownReasonAndSolutionsSuccess
  | GetBreakdownReasonAndSolutionsFailure
  | GetFactoryShiftRevisionDetails
  | GetFactoryShiftRevisionDetailsSuccess
  | GetFactoryShiftRevisionDetailsFailure
  | UpdateShiftRevision
  | UpdateShiftRevisionSuccess
  | UpdateShiftRevisionFailure
  | DeleteShiftRevision
  | DeleteShiftRevisionSuccess
  | DeleteShiftRevisionFailure
  | GetAllMaintenanceTickets
  | GetAllMaintenanceTicketsSuccess
  | GetAllMaintenanceTicketsFailure
  | CreateMaintenanceTicket
  | CreateMaintenanceTicketSuccess
  | CreateMaintenanceTicketFailure
  | StartMaintenanceTicket
  | StartMaintenanceTicketSuccess
  | StartMaintenanceTicketFailure
  | CompleteMaintenanceTicket
  | CompleteMaintenanceTicketSuccess
  | CompleteMaintenanceTicketFailure
  | ReAssignMaintenanceMechanic
  | ReAssignMaintenanceMechanicSuccess
  | ReAssignMaintenanceMechanicFailure
  | ResetSparepartRequestDetails
  | GetSparepartRequestBySource
  | GetSparepartRequestBySourceSuccess
  | GetSparepartRequestBySourceFailure
  | CancelSparepartRequest
  | CancelSparepartRequestSuccess
  | CancelSparepartRequestFailure
  | GetSparepartRequestReasons
  | GetSparepartRequestReasonsSuccess
  | GetSparepartRequestReasonsFailure
  | MarkChecklistCompleted
  | MarkChecklistCompletedSuccess
  | MarkChecklistCompletedFailure
  | SetEmployeeTicketsPagination
  | SetMaintenanceTicketsPagination;
